export default __webpack_public_path__ + "static/media/blank.ab5c235a.svg";